import React from 'react';
import { userApi } from '../api';

export default function Profile({ user, subStatus, onSubscribed, onSubscribe }) {
  const name = user?.name || user?.userName || 'User';
  const plan = subStatus?.plan || 'free';
  const planName = subStatus?.planName || 'Free';
  const status = subStatus?.status || 'trial';
  const endsAt = subStatus?.expiresAt ? new Date(subStatus.expiresAt) : null;
  const activatedAt = subStatus?.activatedAt ? new Date(subStatus.activatedAt) : null;
  const [info, setInfo] = React.useState("");
  const pending = !!subStatus?.requestPending;



  const subscribe = async () => {
    await userApi.activateSubscription('annual');
    await onSubscribed?.();
  };

  return (
    <div className="p-4">
      <div className="bg-white border border-green-100 rounded-2xl p-4 shadow-sm">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 rounded-full bg-green-100 text-green-700 flex items-center justify-center font-bold">
            {String(name).trim().charAt(0).toUpperCase()}
          </div>
          <div>
            <div className="font-semibold text-green-700">{name}</div>
            <div className="text-xs text-gray-500">{user?.email || user?.phone}</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="bg-green-50 rounded-xl p-3 border border-green-100">
            <div className="text-xs text-gray-500">Plan</div>
            <div className="font-semibold text-green-700">{planName}</div>
          </div>
          <div className="bg-green-50 rounded-xl p-3 border border-green-100">
            <div className="text-xs text-gray-500">Status</div>
            <div className={`font-semibold ${subStatus?.valid ? 'text-green-700' : 'text-orange-600'}`}>
              {subStatus?.valid ? 'Active' : 'Inactive'}
            </div>
          </div>
          {endsAt && (
            <div className="bg-green-50 rounded-xl p-3 border border-green-100 col-span-2">
              <div className="text-xs text-gray-500">Valid until</div>
              <div className="font-semibold text-green-700">{endsAt.toDateString()}</div>
            </div>
          )}
          {plan === 'trial' && !endsAt && (
            <div className="bg-green-50 rounded-xl p-3 border border-green-100 col-span-2">
              <div className="text-xs text-gray-500">Trial Plan</div>
              <div className="font-semibold text-green-700">No expiry - use until limits reached</div>
            </div>
          )}
          {activatedAt && (
            <div className="bg-green-50 rounded-xl p-3 border border-green-100 col-span-2">
              <div className="text-xs text-gray-500">Activated on</div>
              <div className="font-semibold text-green-700">{activatedAt.toDateString()}</div>
            </div>
          )}
        </div>

        {!subStatus?.valid && (
          <div className="mt-4">
            <button 
              onClick={onSubscribe} 
              className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors flex items-center justify-center gap-2"
            >
              <span>💳</span>
              Become Pro
            </button>
            <div className="text-xs text-gray-500 mt-2 text-center">
              Choose from Pro or Pro 3-Year plans
            </div>
          </div>
        )}

      </div>
    </div>
  );
}


